import { color } from '../styles/tokens';

/**
 * Container fixo do topo — envolve o header (título "ACIB-OSINT" +
 * status "AO VIVO") e, no mobile, a faixa de chips de camada logo
 * abaixo dele (ver layerChips.ts, que insere a row dentro deste
 * wrapper, não mais como appendChild direto de #hud-root).
 *
 * CORREÇÃO DE BUG (sobreposição do título): antes, .hud-header e
 * .layer-chips-row eram dois elementos `position: absolute`
 * INDEPENDENTES mirando a mesma coordenada (top:8px; left:8px, no
 * mobile), com z-index empatado — a row, inserida depois no DOM
 * (dentro de `map.on('load', ...)` em main.ts, que roda depois de
 * mountHudHeader), vencia o empate e cobria o título. Este wrapper
 * (.hud-header-stack, display:flex, flex-direction:column) elimina o
 * empate de coordenada: cada filho ocupa seu próprio espaço no fluxo
 * normal do flexbox, calculado automaticamente pelo browser — mais
 * robusto que travar uma altura estimada à mão. O título em si
 * (.hud-header) recebe z-index acima de qualquer overlay (ver
 * global.css, --z-hud-header-fixed) — nunca entra na pilha de "um
 * overlay ativo por vez"; é a camada de cima permanente.
 */
export function mountHudHeader(hudRoot: HTMLElement): HTMLElement {
  const stack = document.createElement('div');
  stack.className = 'hud-header-stack';

  const el = document.createElement('div');
  el.className = 'hud-panel hud-header hud-interactive';

  const ping = document.createElement('span');
  ping.className = 'entity-ping';
  ping.style.setProperty('--ping-color', color.accentLive);

  // CORREÇÃO (hierarquia tipográfica — item 2 do diagnóstico): antes,
  // o tamanho da fonte do título vinha de um inline style solto
  // (`title.style.fontSize = '15px'`), inconsistente com o resto do
  // design system, que usa classes utilitárias. Nova classe
  // `.hud-title` (global.css) sistematiza isso.
  const title = document.createElement('span');
  title.className = 'heading hud-title';
  title.textContent = 'ACIB-OSINT';
  title.style.color = color.textPrimary;

  const status = document.createElement('span');
  status.className = 'label-secondary mono';
  status.textContent = 'AO VIVO';
  status.style.color = color.accentLive;

  el.append(ping, title, status);
  stack.appendChild(el);
  hudRoot.appendChild(stack);

  return stack;
}
